import React, { useRef, useState, useEffect } from 'react';
import Otp_Ico from '../../../../Assets/Images/otp.png'
import { showToast } from '../../../../Component/Toast';
import axios from 'axios'
import Button from '../../../../Component/Button'
import useEmployeeHook from "../../useEmployeeHook";

function Index(props) {
    const URL = useEmployeeHook()
    let email = props.email
    let OTP = useRef();
    const [OTPTimer, setOTPTimer] = useState(30);

    const resendOTP = () => {
        axios.post(URL.emailOtp, {email, client_id: props.client_id, ...(props.provider?{origin: props.provider}:undefined)}).then(res => {
            if(res){
                showToast({
                    type: 'success',
                    message: res.data.message || "OTP sent to your Email"
                })
                setOTPTimer(30)
            }
        }).catch(err => {
            if(err.response){
                showToast({
                    type: 'error',
                    message: err.response.data
                })
            }else if(err.request){
                let msg = JSON.parse(err.request.response)
                showToast({
                    type: 'error',
                    message: msg.message
                })
            }
        })
    }

    useEffect(() => {
        if(OTPTimer){
            let INTERVAL = setTimeout(() => {
                if(OTPTimer < 1){
                    clearInterval(INTERVAL)
                    setOTPTimer()
                }else{
                    setOTPTimer(prev=>prev-1)
                }
            }, 1000);
        }
    }, [OTPTimer]);

    const moveNext = e => {
        let otp = OTP.current.value;
        if(!otp){
            showToast({
                type: 'error',
                message: "Enter OTP, sent on your Email"
            })
            return
        }
        props.onSuccess(otp)
	}

    return (
       <div className="container" style={{height: '100vh'}}>
            <div className="row justify-content-center h-100-center">
                <div className="col-md-6 pt-4">
                    <div data-aos="fade-left" className="p-3 text-center" style={{backgroundColor: '#fff', borderRadius: '1rem', maxWidth: 400, boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important', margin: 'auto'}}>
                        <img className="img-fluid mb-4" src={Otp_Ico} alt='Lock' style={{maxWidth: 80}} />
                        <h1 className="display-6 fw-bold">Verify Email</h1>
                        <p>An OTP has been sent to your registered email or phone,&nbsp;
                            {
                                OTPTimer?
                                <span className='text-primary'>Resend OTP in {OTPTimer}s</span>:
                                <span onClick={resendOTP} className='text-primary' style={{cursor: 'pointer', fontSize: '0.9rem'}}>Resend OTP</span>
                            }
                        </p>
                        <div className="mt-4 mb-4">
                            <div>
                                <input ref={OTP} type="text" className="form-control mb-4" placeholder="Enter OTP" />
                                <Button onClick={moveNext} name='Verify' loading={false} />
                            </div>
                        </div>
                        <p className="mt-3" style={{fontSize: '0.9rem'}}>
                            <a className="text-parimary" href={`/?origin=${props.origin}`}>Back to Login</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Index;
